import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/common/confirmation-dialog/confirmation-dialog.component';
import { Router } from "@angular/router";
import { WalletService } from "@services/wallet/wallet.service";
import { UserService } from "@services/backend/user.service";
import { Observable, combineLatest, of, switchMap, tap } from 'rxjs';
import { UserProfile } from '@interfaces/user-profile.interface';
import { AuthService } from '@services/auth.service';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-sidemenu',
	templateUrl: './sidemenu.component.html',
	styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements OnInit {

	app: string = environment.APP;
	isActive: boolean = false;
	isContractor: boolean = false;
	walletBadgers: any = null;
	userBadgers: any = null;
	openMenu: any = '';

	constructor(
		public dialog: MatDialog,
		public router: Router,
		private auth: AuthService,
		private userService: UserService,
		private walletService: WalletService) {
	}

	ngOnInit() {
		this.userService.userProfile$.pipe(
			tap((profile: UserProfile) => {
				this.isActive = profile.status == 'ACTIVE';
				this.isContractor = profile.type == 'CONTRACTOR';
			}),
			switchMap(() => this.isActive ? combineLatest([this.getWalletBadgers(), this.getUserBadgers()]) : of())
		).subscribe();
	}

	getWalletBadgers(): Observable<any> {
		return this.walletService.getBadgers().pipe(
			tap((res: any) => this.walletBadgers = res.body)
		);
	}

	getUserBadgers(): Observable<any> {
		return this.userService.getBadgers().pipe(
			tap((res: any) => this.userBadgers = res.body)
		);
	}

	openSideMenu() {
		if (this.openMenu == 'show')
			this.openMenu = '';
		else
			this.openMenu = 'show';
	}

	logout() {
		this.openSideMenu();
		const dialogRef =
			this.dialog.open(ConfirmationDialogComponent, {
				width: '500px',
				disableClose: true,
				panelClass: 'custom-modal-box',
				hasBackdrop: true,
				data: {
					title: 'sign_out.title',
					message: 'sign_out.message',
					buttonText: {
						ok: 'common.continue',
						cancel: 'common.cancel'
					}
				}
			});
		dialogRef.afterClosed()
			.subscribe((confirmed: boolean) => {
				if (confirmed) {
					this.userService.logout();
					this.auth.logout();
				}
			});
	}

}
